<template>
  <b-modal
    @ok.prevent="saveTimetable"
    size="lg"
    v-model="localShow"
    ok-title="Przypisz nowy harmonogram"
    cancel-title="Anuluj"
    @hidden="$emit('close', timetables)"
  >
    <b-list-group>
      <b-list-group-item v-for="timetable in timetables" :key="timetable.timetable.id">
        <b-row>
          <b-col cols="6" class="align-self-center">{{ timetable.timetable.name }}</b-col>
          <b-col cols="5" class="align-self-center">
            {{ timetable.startDate | moment('DD-MM-YYYY') }}
            <span
              v-show="timetable.endDate"
            >- {{ timetable.endDate | moment('DD-MM-YYYY') }}</span>
          </b-col>
          <b-col cols="1">
            <b-btn @click="removeTimetable(timetable.id)" size="sm" variant="outline-danger">
              <i class="fa fa-fw fa-trash"></i>
            </b-btn>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <hr v-show="timetables && timetables.length > 0" />
    <div>
      <label for="timetable">Harmonogram</label>
      <v-select id="timetable" label="name" v-model="selected" :options="list"></v-select>
    </div>
    <b-row>
      <b-col>
        <app-datepicker class="dateInput" :model="$schema.startDate"></app-datepicker>
      </b-col>
      <b-col>
        <app-datepicker class="dateInput" :model="$schema.endDate"></app-datepicker>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import moment from 'moment';

import formMixin from '@/mixins/formMixin';
import { TimetableResource } from '@/resources/timetable.resource';
const schema = {
  title: 'Datepicker',
  type: 'object',
  properties: {
    startDate: {
      type: 'string',
      format: 'date',
      title: 'Data rozpoczęcia',
      fieldRequired: 'true'
    },
    endDate: {
      type: 'string',
      format: 'date',
      title: 'Data zakończenia',
      fieldRequired: 'false'
    }
  }
};
export default {
  mixins: [formMixin],
  schema,
  props: ['timetables', 'userId', 'show'],
  components: { moment },
  data() {
    return {
      localShow: false,
      list: [],
      selected: undefined,
      startDate: new Date()
    };
  },
  methods: {
    async getTimetableList() {
      try {
        const data = await TimetableResource.getBasic();
        this.list.push(...data.timetables);
      } catch (error) {
        this.$notify({ title: 'błąd', text: 'Wystąpił błąd podzczas pobierania harmonogramów', type: 'error' });
        console.warn(error);
      }
    },
    async saveTimetable() {
      if (this.$schema.$validateAll().length !== 0 || !this.selected) {
        return;
      }
      try {
        const data = await TimetableResource.setTimetableToEmployee(this.userId, this.selected.id, this.$schema.$model);
        this.timetables.push(data.employeeTimetableSet);
        this.$emit('close', timetables);
      } catch (error) {
        this.$notify({ title: 'błąd', text: 'Wystąpił błąd podzczas dodawnia harmonogramu', type: 'error' });
        console.warn(error);
      }
    },
    async removeTimetable(id) {
      if (!confirm('Czy napewno chcesz usunąć ten harmonogram?')) {
        return;
      }
      try {
        await TimetableResource.employeeTimetableRemove(id);
        this.timetables.splice(this.timetables.findIndex(item => item.id === id), 1);
      } catch (error) {
        this.$notify({ title: 'błąd', text: 'Wystąpił błąd podzczas usuwania harmonogramu', type: 'error' });
        console.warn(error);
      }
    }
  },
  created() {
    this.getTimetableList();
  },
  watch: {
    show(prev, next) {
      this.localShow = prev;
    }
  }
};
</script>
